module.exports = __webpack_public_path__ + "img/hub.fc30da20.png";